import type { NotificationRowGroup } from "@productlane/lib/src/notifications/grouping"
import type { NotificationRow } from "@productlane/zero/schema"
import {
	formatUnreadCount,
	groupNotificationRows,
} from "@productlane/lib/src/notifications/grouping"

export type NotificationGroup<T extends NotificationRow = NotificationRow> =
	NotificationRowGroup<T>

export function groupNotifications<T extends NotificationRow>(
	rows: readonly T[],
): NotificationGroup<T>[] {
	return groupNotificationRows(rows)
}

export { formatUnreadCount }
